import {
    callNewPassword,
    callPhoneSendVerification,
    callVerifyPhone,
} from "@/api-connector/play-digital-api/metods/account/registration-api";
import { isErrorDto, parseErrorMessage } from "../utils/user-account-helper";

export async function phoneSendVerificationService(phone: string): Promise<void> {
    try {
        await callPhoneSendVerification(phone);
    } catch (ex: unknown) {
        return Promise.reject(parseErrorMessage(ex, "Při odeslání PINu došlo k chybě."));
    }
}

export async function verifyPhoneService(phone: string, pin: string): Promise<void> {
    try {
        await callVerifyPhone(phone, pin);
    } catch (ex: unknown) {
        return Promise.reject(parseErrorMessage(ex, "Pin není správný."));
    }
}

export async function newPasswordService(password: string, token: string): Promise<void> {
    try {
        await callNewPassword(password, token);
    } catch (ex: unknown) {
        if (isErrorDto(ex)) {
            if (ex.code == "183") return Promise.reject("Tohle heslo bylo použité již v minulosti. Zadejte prosím jiné.");
        }
        return Promise.reject("Změna hesla neproběhla úspěšně, zkuste to prosím znovu.");
    }
}
